import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { firstValueFrom, lastValueFrom, Observable } from 'rxjs';
import { environment, SERVER_URL } from 'src/environments/environment';
import { Bill, BillResponse } from '../interface/invoice-interface';
import { StorageService } from './storage.service';


@Injectable({
  providedIn: 'root',
})
export class BillsServiceService {
  private jsonURL = 'assets/bill-mock.json';

  pendingCount = signal<number>(0);
  refreshTrigger = signal<boolean>(false);

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  getBills(
    created__gte: string,
    created__lte: string,
    number_of_bills: number,
    offset: number
  ) {
    const headers = this.storageService.getSimpleAuthHeaders();
    return this.http
      .get(
        SERVER_URL +
          '/mall/admin/pending-bills/?limit=' +
          number_of_bills +
          '&offset=' +
          offset +
          '&created__gte=' +
          created__gte +
          '&created__lte=' +
          created__lte,
        { headers }
      )
      .toPromise();
  }

  async approveBill(bill_number: any) {
    const url = `${SERVER_URL}/mall/admin/pending-bills/${bill_number}/`;
    const body = {
      status: 'VALID',
      reject_reason: '',
    };
    const headers = this.storageService.getAuthHeaders();

    try {
      const response = await this.http.put(url, body, headers).toPromise();
      // console.log('Factura aprobada con exito:', response);
    } catch (error) {
      console.error('Error al aprobar factura:', error);
    }
  }

  async rejectBill(bill_number: any, reject_reason: any) {
    const url = `${SERVER_URL}/mall/admin/pending-bills/${bill_number}/`;
    const body = {
      status: 'REJECTED',
      reject_reason: reject_reason,
    };
    const headers = this.storageService.getAuthHeaders();

    try {
      const response = await this.http.put(url, body, headers).toPromise();
      // console.log('Factura rechazada con exito:', response);
    } catch (error) {
      console.error('Error al rechazar factura:', error);
    }
  }

  getSimilarBills(id: any) {
    // console.log('id es', id);
    const headers = this.storageService.getSimpleAuthHeaders();
    return this.http
      .get(
        SERVER_URL +
          '/mall/admin/similar-bills/?bill_number=' +
          id +
          '&limit=10',
        { headers }
      )
      .toPromise();
  }

  getLastBills(quantity: number, last_date: any, user: any) {
    const params = {
      quantity: quantity,
      last_date: last_date,
      user: user,
    };
    const headers = this.storageService.getSimpleAuthHeaders();
    return this.http
      .get(SERVER_URL + '/mall/admin/last-bills/', { params, headers })
      .toPromise();
  }

  getInformation() {
    const headers = this.storageService.getSimpleAuthHeaders();
    return this.http
      .get(SERVER_URL + '/mall/admin/summary/?mall=1', { headers })
      .toPromise();
  }

  getCountApproveBillsPerMonthData() {
    const headers = this.storageService.getSimpleAuthHeaders();
    return this.http
      .get(SERVER_URL + '/mall/admin/count-approved-per-month/', { headers })
      .toPromise();
  }

  getCountOfBillsPerMonth() {
    const headers = this.storageService.getSimpleAuthHeaders();
    return this.http
      .get(SERVER_URL + '/mall/admin/count-total-per-month/', { headers })
      .toPromise();
  }

  getBillMock(): Observable<Bill[]> {
    return this.http.get<Bill[]>(this.jsonURL);
  }

  getBillsByCustomer(params?: any) {
    const headers = this.storageService.getSimpleAuthHeaders();

    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        httpParams = httpParams.append(key, params[key]);
      }
    });
    const options = {
      ...headers,
      params: httpParams,
    };
    return this.http
      .get<BillResponse>(environment.url + '/thoth/bills/list', options)
      .toPromise();
  }

  getBillDetail(id: string) {
    const headers = this.storageService.getSimpleAuthHeaders();
    return this.http
      .get<any>(environment.url + '/thoth/bills/detail/' + id, { headers })
      .toPromise();
  }

  getBillsPending(params?: any) {
    const headers = this.storageService.getSimpleAuthHeaders();

    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        httpParams = httpParams.append(key, params[key]);
      }
    });
    //httpParams.append('customer',this.storageService.getSelectedMall()?.id )

    const options = {
      ...headers,
      params: httpParams,
    };
    return this.http
      .get<BillResponse>(environment.url + '/thoth/bills/pending', options)
      .toPromise();
  }

  async changeState(bill_number: string, state: string, reason: string | null) {
    const url = `${environment.url}/thoth/bills/validation/${bill_number}`;

    const body = {
      state,
      //reason
    };

    const headers = this.storageService.getSimpleAuthHeaders();

    const options = {
      headers: headers,
    };

    try {
      const response = await this.http.put(url, body, options).toPromise();
      // console.log('Actualizada con éxito:', response);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async updateBill(bill_number: string, body: any) {
    console.log('body: ', body, 'bill_number: ', bill_number)
    const url = `${environment.url}/thoth/bills/update/${bill_number}`;

    const headers = this.storageService.getSimpleAuthHeaders();

    const options = {
      headers: headers,
    };

    return lastValueFrom(this.http.put(url, body, options)).then(
      (response: any) => {
        return response;
      }
    );
  }

  getUserSummary(ids: any[], start_date: any, end_date: any) {
    const url =
      environment.url +
      '/thoth/bills/user-summary?user_ids=' +
      ids.join(',') +
      '&start_date=' +
      start_date +
      '&end_date=' +
      end_date;
    const httpOptions = this.storageService.getAuthHeaders();
    return lastValueFrom(this.http.get(url, httpOptions)).then(
      (response: any) => {
        return response;
      }
    );
  }

  // getUserContestSummary(userId: any, campaingId: any) {
  //   const url =
  //     environment.url +
  //     '/thoth/bills/user-summary/campaign?user_id=' +
  //     userId +
  //     '&campaings_id=' +
  //     campaingId;
  //   const httpOptions = this.storageService.getAuthHeaders();
  //   return lastValueFrom(this.http.get(url, httpOptions)).then(
  //     (response: any) => {
  //       return response;
  //     }
  //   );
  // }


  getUserContestSummary(campaingId: any) {
    const token = this.storageService.getSessionToken();

    const url =
      environment.url +
      '/thoth/bills/user-summary/campaign?token=' +
      token +
      '&campaings_id=' +
      campaingId;

    const httpOptions = this.storageService.getAuthHeaders();

    return firstValueFrom(this.http.get(url, httpOptions)).then(
      (response: any) => {
        return response;
      }
    );
  }

  getBillByNumberAndCampaign(bill_number: string, campaign_id: string) {
    const url = `${environment.url}/thoth/bills/bill`;
    const headers = this.storageService.getSimpleAuthHeaders();

    const params = new HttpParams()
      .set('bill_number', bill_number)
      .set('campaign_id', campaign_id);

    return this.http.get<any>(url, { headers, params }).toPromise();
  }

  changeBillToNewUser(bill_id: any, user_id: any) {
    const url = `${environment.url}/thoth/bills/change-user`;
    const httpOptions = this.storageService.getAuthHeaders();
    const body = {
      bill_id: bill_id,
      user_id: user_id
    }

    return lastValueFrom(this.http.put(url, body, httpOptions)).then(
      (response: any) => {
        return response;
      }
    );
  }

  setCount(value: number) {
    this.pendingCount.set(value);
  }

  triggerRefresh() {
    this.refreshTrigger.update(v => !v);
  }

}
